import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";

const UpdateRateList = ({ selectedRowsData, updateHandleChange, getData }) => {
  // const companyName = selectedRowsData.company?.company_name || "";
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };
  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const { id, discom_name } = selectedRowsData;

    let BASE_URL = SERVER_URL + `/api/discom/discom-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_name,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Discom Name
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                // onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      onSubmit={handleUpdateDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="discom_name">Discom Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="discom_name"
                              id="discom_name"
                              placeholder="Enter Discom Name"
                              value={selectedRowsData.discom_name}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleUpdateDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateRateList;
